import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const HeroSection: React.FC = () => {
  const scrollToPricing = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-10 md:pt-24 md:pb-20 px-4 overflow-hidden" data-id="element-43">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[800px] h-[600px] md:h-[800px] bg-gold-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-44"></div>

      {/* Mobile: stacked centered layout */}
      <div className="max-w-md mx-auto relative z-10 text-center md:hidden" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-46">
          <h1 className="text-3xl font-extrabold leading-tight mb-6 text-white" data-id="element-47">
            DEJÁ DE IMPROVISAR EN SESIÓN Y EMPEZÁ A TRABAJAR CON{' '}
            <span className="text-gold-500" data-id="element-48">CLARIDAD CLÍNICA.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mb-6" data-id="element-49">
          <img src="https://cdn.magicpatterns.com/uploads/bBsFBKQXBHswwgpFimuZYX/Diseno_sin_titulo_(16).png" alt="KIT Sesiones Clínicas" className="w-[72%] mx-auto h-auto drop-shadow-2xl cursor-pointer" onClick={scrollToPricing} data-id="element-50" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-51">
          <p className="text-base text-gray-300 mb-6 leading-relaxed" data-id="element-52">
            <strong className="text-white" data-id="element-53">KIT Sesiones Clínicas</strong>
            <br data-id="element-54" />
            El primer sistema práctico para psicólogos/as que te da el paso a
            paso para estructurar sesiones, sentirte más seguro/a y generar
            avances reales con tus pacientes desde el día 1.
          </p>

          <CTAButton className="mb-3" data-id="element-55" />
          <p className="text-sm text-gray-400 mb-6" data-id="element-56">
            $19.990 ARS · Acceso inmediato
          </p>

          <ul className="space-y-3 text-left" data-id="element-57">
            {['Método SESIÓN 4F: Chau a la improvisación y las dudas.', 'Plantillas Clínicas Profesionales: Organizá cada sesión en minutos.', 'Recursos de Intervención Rápida: Qué decir y cómo avanzar cuando la sesión se traba.', 'Descargás. Aplicás. Trabajás mejor.'].map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4 + i * 0.08
          }} className="flex items-start gap-2 text-gray-200 text-sm" data-id="element-58">
                <CheckCircle className="w-5 h-5 text-gold-500 shrink-0 mt-0.5" data-id="element-59" />
                <span data-id="element-60">{item}</span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>

      {/* Desktop: two-column layout */}
      <div className="hidden md:grid max-w-6xl mx-auto grid-cols-2 gap-16 items-center relative z-10" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-62">
          <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-white" data-id="element-63">
            DEJÁ DE IMPROVISAR EN SESIÓN Y EMPEZÁ A TRABAJAR CON{' '}
            <span className="text-gold-500" data-id="element-64">CLARIDAD CLÍNICA.</span>
          </h1>

          <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-65">
            <strong className="text-white" data-id="element-66">KIT Sesiones Clínicas</strong>
            <br data-id="element-67" />
            El primer sistema práctico para psicólogos/as que te da el paso a
            paso para estructurar sesiones, sentirte más seguro/a y generar
            avances reales con tus pacientes desde el día 1.
          </p>

          <CTAButton className="mb-3" data-id="element-68" />
          <p className="text-sm text-gray-400 mb-8 text-center" data-id="element-69">
            $19.990 ARS · Acceso inmediato
          </p>

          <ul className="space-y-4" data-id="element-70">
            {['Método SESIÓN 4F: Chau a la improvisación y las dudas.', 'Plantillas Clínicas Profesionales: Organizá cada sesión en minutos.', 'Recursos de Intervención Rápida: Qué decir y cómo avanzar cuando la sesión se traba.', 'Descargás. Aplicás. Trabajás mejor.'].map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4 + i * 0.1
          }} className="flex items-start gap-3 text-gray-200" data-id="element-71">
                <CheckCircle className="w-6 h-6 text-gold-500 shrink-0 mt-0.5" data-id="element-72" />
                <span data-id="element-73">{item}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center" data-id="element-74">
          <img src="https://cdn.magicpatterns.com/uploads/bBsFBKQXBHswwgpFimuZYX/Diseno_sin_titulo_(16).png" alt="KIT Sesiones Clínicas" className="w-[85%] h-auto drop-shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-500" onClick={scrollToPricing} data-id="element-75" />
        </motion.div>
      </div>
    </section>;
};